import _home from "@/views/layouts/home/_home.vue";
import _activity from "@/views/layouts/activity/index.vue";

export default [
    {
        path: "/",
        name: "_home",
        redirect: "/index",
        component:_home,
        children: [
            {
                path: "/index",
                name: "index",
                component: () => import(/* webpackChunkName: "home" */"../views/Home/Index.vue"),
                meta: {
                    title: "赛事列表",
                    requiresAuth: true,
                    showloading: false
                }
            },
            // {
            //     path: "/index",
            //     name: "index",
            //     component: () => import(/* webpackChunkName: "home" */"../views/Match/Index/index.vue"),
            //     meta: {
            //         title: "2022年体锻达标赛",
            //         share: true,
            //         requiresAuth: false,
            //         showloading: false,
            //         bgcolor:"#F5F5F5"
            //     }
            // },
            // {
            //     path: "/health",
            //     name: "health",
            //     component: () => import(/* webpackChunkName: "exchange" */"../views/Health/Index/index.vue"),
            //     meta: {
            //         title: "健康课堂",
            //         share: true,
            //         showloading: false,
            //         requiresAuth: true,
            //         keepAlive: true
            //     }
            // },        
            // {
            //     path: "/exchange",
            //     name: "exchange",
            //     component: () => import(/* webpackChunkName: "exchange" */"../views/Exchange/Index/index.vue"),
            //     meta: {
            //         title: "积分乐换",
            //         showloading: false,
            //         requiresAuth: true,
            //         share: true,
            //         keepAlive: true
            //     }
            // },
            
            {
                path: "/my",
                name: "my",
                component: () => import(/* webpackChunkName: "my" */"../views/My/Index/index.vue"),
                meta: {
                    title: "个人中心",
                    showloading: false,
                    requiresAuth: true,
                    bgcolor:"#F5F5F5"
                }
            }
        ]
    },
    {
        path: '/login',
        name: "login",
        component: () => import('@/views/Login/index'),
        meta: {
            title: "登录",
            bgcolor:"#FFFFFF"
        }
    },
    {
        path: '/pause',
        name: "pause",
        component: () => import('@/views/over'),
        meta: {
            title: "停服",
            bgcolor:"#FFFFFF"
        }
    },
    {
        path: "/matchindex",
        name: "matchindex",
        component: () => import(/* webpackChunkName: "home" */"../views/Match/Index/index.vue"),
        meta: {
            title: "评估记录",
            share: true,
            requiresAuth: false,
            showloading: false,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/matchdetail/:evid",
        name: "matchdetail",
        component: () => import(/* webpackChunkName: "home" */"../views/Match/Detail/index.vue"),
        meta: {
            title: "评估详情",
            share: true,
            requiresAuth: false,
            showloading: false,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/rule",
        name: "rule",
        component: () => import(/* webpackChunkName: "my" */"../views/Match/Rule/index.vue"),
        meta: {
            title: "线上达标赛",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#fff"
        }
    },
    // {
    //     path: "/sports/:sports_id/:item_id",
    //     name: "sports",
    //     component: () => import(/* webpackChunkName: "home" */"../views/Home/Index.vue"),
    //     meta: {
    //         title: "2022年体锻达标赛",
    //         share: true,
    //         requiresAuth: false,
    //         showloading: false
    //     }
    // },
    {
        path: "/join1/:matchid?",
        name: "joinMatch1",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Match/SignUp/index1.vue"),
        meta: {
            title: "赛事评估(第一步)",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/join/:evid/:matchid?",
        name: "joinMatch",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Match/SignUp/index.vue"),
        meta: {
            title: "赛事评估（提交）",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    }
];
